module.exports = __webpack_public_path__ + "img/389.44d48658.jpg";